window.replaceDomElement = function (data, element) {
    if (data && element) {
        let spanWrapper = document.createElement('span')
        spanWrapper.innerHTML = data
        element.replaceWith(spanWrapper)
    }
}

window.escapeHTML = function (str) {
    return str
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/\\/g, "&#92;")
        .replace(/'/g, "&#39;");
}

window.logoutSSOUser = function(link) {
    $.ajax({
        url: "/logout/ajax",
        type: 'POST',
        data: {},
        success: function(result) {
            window.location.href = link
        },
        error: function(error){
            console.log("Error: ", error)
        }
    });
}

window.updateClosedCourse = function(time, reload) { // , unitId = 0

    sessionStorage.setItem('course_active', 0);
    sessionStorage.setItem('iframe_active', 0);
    sessionStorage.setItem('popup_active', 0);

    setTimeout(function() {

        const currentUri = window.location.href;
        const currentParts = currentUri.split('/');
        const currentId = currentParts[currentParts.length - 2];

        $.ajax({
            type: 'POST',
            url: '/close/course',
            async: false,
            data: {
                // unit_id: unitId,
                page_path: window.location.pathname
            },
            success: function (response) {

                let unitId = response.unit_id

                if (window.location.href.includes("series") || window.location.href.includes("learning_box")) {
                    const uri = window.location.href;
                    const parts = uri.split('/');
                    const id = parts[parts.length - 2];

                    let mainObject = window.global_vars.unit_types.series
                    if (window.location.href.includes("learning_box")) {
                        mainObject = window.global_vars.unit_types.learning_box
                    }

                    loadUnitDetails(id, mainObject, id, [unitId, window.global_vars.unit_types.course]);

                    let iframeHolder = document.getElementById('iframe_holder')
                    if (iframeHolder) {
                        iframeHolder.src = "";
                    }

                    $('#course_overlay').hide();

                    // TODO if we are on course/id/info page and id is not equal to unitId, we need to redirect to new version page
                } else if (currentUri.includes('/course/') && currentId != unitId) {

                    // on this element we have value if user needs to be redirected
                    let courseStartBtn = document.getElementById('course-start-btn-' + unitId)
                    if (courseStartBtn.dataset.pageRedirect == 1) {
                        location.href = '/course/' + unitId + '/info'
                    }

                } else {

                    let iframeHolder = document.getElementById('iframe_holder')
                    if (iframeHolder) {
                        iframeHolder.src = "";
                    }

                    loadUnitDetails(unitId, window.global_vars.unit_types.course, null);

                    $('#course_overlay').hide();

                    if (response.unitMessage) {
                        window.notification('success', response.unitMessage)
                    }
                }

            }, error: function(err) {
                location.reload()
            }

        });
    }, time);
    if(typeof saveNotes !== 'undefined' && typeof saveNotes === 'function'){
        saveNotes(true);
    }
}

window.renderSequentialLockIcon = function(unlocked) {
    if (unlocked) {
        return '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">\n' +
            '        <defs>\n' +
            '            <style>\n' +
            '                .unlock_icon_a{fill:#fff; stroke: var(--positiveTextColor) }\n' +
            '            </style>\n' +
            '        </defs>\n' +
            '        <path class="unlock_icon_a" d="M58,611.018a6.95,6.95,0,0,1,6.9-6.98,6.788,6.788,0,0,1,2.867.638v-1a5.615,5.615,0,1,1,11.229,0v1.552a.317.317,0,0,1-.316.32H76.471a.317.317,0,0,1-.316-.32v-1.552a2.77,2.77,0,1,0-5.54,0V607.1A6.931,6.931,0,1,1,58,611.018Zm.632,0a6.272,6.272,0,1,0,6.271-6.341A6.314,6.314,0,0,0,58.631,611.018Zm9.77-7.34v1.334a6.935,6.935,0,0,1,1.58,1.3v-2.63a3.4,3.4,0,1,1,6.8,0v1.233h1.58v-1.233a4.983,4.983,0,1,0-9.966,0Zm-3.815,11.011v-2.156a1.695,1.695,0,1,1,.632,0v2.156a.316.316,0,1,1-.632,0Zm-.746-3.838a1.063,1.063,0,1,0,1.062-1.075A1.069,1.069,0,0,0,63.841,610.852Z" transform="translate(-58 -598)"></path>\n' +
            '    </svg>'
    }

    return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="20" viewBox="0 0 14 20">\n' +
        '        <defs>\n' +
        '            <style>\n' +
        '                .lock_icon_a{fill:none;}.lock_icon_b{fill:#fff; stroke: var(--positiveTextColor) }.lock_icon_c{clip-path:url(#lock_icon_a);}\n' +
        '            </style>\n' +
        '            <clipPath id="lock_icon_a"><rect class="lock_icon_aa" width="14" height="20"/></clipPath>\n' +
        '        </defs>\n' +
        '        <g transform="translate(-61 -1168)">\n' +
        '            <g transform="translate(61 1168)">\n' +
        '                <g class="lock_icon_c">\n' +
        '                    <path d="M12.692,8.97s0-.005,0-.008V5.678a5.693,5.693,0,0,0-11.387,0V8.972A6.922,6.922,0,0,0,0,13.019a7,7,0,0,0,14,0A6.923,6.923,0,0,0,12.692,8.97M1.948,5.678a5.053,5.053,0,0,1,10.1,0V8.2a7.033,7.033,0,0,0-1.6-1.248V5.678a3.45,3.45,0,0,0-6.9,0V6.952A7.036,7.036,0,0,0,1.948,8.2Zm7.862.951a6.968,6.968,0,0,0-5.618,0V5.678a2.809,2.809,0,0,1,5.618,0ZM7,19.361a6.342,6.342,0,1,1,6.359-6.342A6.358,6.358,0,0,1,7,19.361"/>\n' +
        '                    <path d="M7,9.86a1.712,1.712,0,0,0-.32,3.395v2.156a.32.32,0,0,0,.641,0V13.255A1.712,1.712,0,0,0,7,9.86m0,2.788a1.074,1.074,0,1,1,1.077-1.074A1.077,1.077,0,0,1,7,12.648"/>\n' +
        '                </g>\n' +
        '            </g>\n' +
        '            <path class="lock_icon_b" d="M61,1181.019a6.925,6.925,0,0,1,1.307-4.046v-3.294a5.693,5.693,0,0,1,11.387,0v3.284s0,.005,0,.008A6.922,6.922,0,0,1,75,1180.912v.216a7,7,0,0,1-14-.11Zm.641,0A6.359,6.359,0,1,0,68,1174.677,6.358,6.358,0,0,0,61.641,1181.019Zm9.809-7.34v1.273a7.049,7.049,0,0,1,1.6,1.248v-2.522a5.053,5.053,0,0,0-10.105,0v2.522a7.044,7.044,0,0,1,1.6-1.248v-1.273a3.45,3.45,0,0,1,6.9,0Zm-.641.95v-.95a2.809,2.809,0,0,0-5.618,0v.95a6.967,6.967,0,0,1,5.618,0Zm-3.129,8.782v-2.156a1.718,1.718,0,1,1,.641,0v2.156a.32.32,0,1,1-.641,0Zm-.757-3.838A1.077,1.077,0,1,0,68,1178.5,1.077,1.077,0,0,0,66.923,1179.573Z"/>\n' +
        '        </g>\n' +
        '    </svg>'
}

window.setSequentialLockIcon = function(seqItemLine, unlocked) {
    const svgWrapper = seqItemLine && seqItemLine.find('div.lock-icon')
    if (!svgWrapper.length) {
        return
    }

    svgWrapper.toggleClass('unlock unlock-icon', unlocked)
    svgWrapper.html(window.renderSequentialLockIcon(unlocked))
}

window.updateLockIcon = function(elem) {

    try {
        const sequentialItemLine = elem.parent().prev('.sequential-item-line');
        const sequentialAccess = elem.attr('data-sequential-access');

        if (!sequentialItemLine.length || sequentialAccess === undefined) {
            return
        }

        window.setSequentialLockIcon(sequentialItemLine, sequentialAccess === '1')
    } catch (e) {
        console.log(e)
    }

    return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="20" viewBox="0 0 14 20">\n' +
        '        <defs>\n' +
        '            <style>\n' +
        '                .lock_icon_a{fill:none;}.lock_icon_b{fill:#fff; stroke: var(--positiveTextColor) }.lock_icon_c{clip-path:url(#lock_icon_a);}\n' +
        '            </style>\n' +
        '            <clipPath id="lock_icon_a"><rect class="lock_icon_aa" width="14" height="20"/></clipPath>\n' +
        '        </defs>\n' +
        '        <g transform="translate(-61 -1168)">\n' +
        '            <g transform="translate(61 1168)">\n' +
        '                <g class="lock_icon_c">\n' +
        '                    <path d="M12.692,8.97s0-.005,0-.008V5.678a5.693,5.693,0,0,0-11.387,0V8.972A6.922,6.922,0,0,0,0,13.019a7,7,0,0,0,14,0A6.923,6.923,0,0,0,12.692,8.97M1.948,5.678a5.053,5.053,0,0,1,10.1,0V8.2a7.033,7.033,0,0,0-1.6-1.248V5.678a3.45,3.45,0,0,0-6.9,0V6.952A7.036,7.036,0,0,0,1.948,8.2Zm7.862.951a6.968,6.968,0,0,0-5.618,0V5.678a2.809,2.809,0,0,1,5.618,0ZM7,19.361a6.342,6.342,0,1,1,6.359-6.342A6.358,6.358,0,0,1,7,19.361"/>\n' +
        '                    <path d="M7,9.86a1.712,1.712,0,0,0-.32,3.395v2.156a.32.32,0,0,0,.641,0V13.255A1.712,1.712,0,0,0,7,9.86m0,2.788a1.074,1.074,0,1,1,1.077-1.074A1.077,1.077,0,0,1,7,12.648"/>\n' +
        '                </g>\n' +
        '            </g>\n' +
        '            <path class="lock_icon_b" d="M61,1181.019a6.925,6.925,0,0,1,1.307-4.046v-3.294a5.693,5.693,0,0,1,11.387,0v3.284s0,.005,0,.008A6.922,6.922,0,0,1,75,1180.912v.216a7,7,0,0,1-14-.11Zm.641,0A6.359,6.359,0,1,0,68,1174.677,6.358,6.358,0,0,0,61.641,1181.019Zm9.809-7.34v1.273a7.049,7.049,0,0,1,1.6,1.248v-2.522a5.053,5.053,0,0,0-10.105,0v2.522a7.044,7.044,0,0,1,1.6-1.248v-1.273a3.45,3.45,0,0,1,6.9,0Zm-.641.95v-.95a2.809,2.809,0,0,0-5.618,0v.95a6.967,6.967,0,0,1,5.618,0Zm-3.129,8.782v-2.156a1.718,1.718,0,1,1,.641,0v2.156a.32.32,0,1,1-.641,0Zm-.757-3.838A1.077,1.077,0,1,0,68,1178.5,1.077,1.077,0,0,0,66.923,1179.573Z"/>\n' +
        '        </g>\n' +
        '    </svg>';
}

window.setSequentialLockIcon = function(seqItemLine, unlocked) {
    const svgWrapper = seqItemLine && seqItemLine.find('div.lock-icon');
    if (!svgWrapper.length) {
        return;
    }

    svgWrapper.toggleClass('unlock unlock-icon', unlocked);
    svgWrapper.html(window.renderSequentialLockIcon(unlocked));
}

window.refreshSkillLockedUnits = function(collectionId, currentItemData = []) {
    const lockedButtons = document.querySelectorAll('.skill_requirements_message');
    if (!lockedButtons.length) {
        return;
    }

    const itemsToRefresh = new Map();
    lockedButtons.forEach((button) => {
        const container = button.closest('[id^="main-details-"]');
        if (!container) {
            return;
        }

        const unitId = container.getAttribute('data-id');
        const unitType = container.getAttribute('data-unit-type');
        if (!unitId || !unitType) {
            return;
        }

        if (currentItemData.length > 1 && unitId == currentItemData[0] && unitType == currentItemData[1]) {
            return;
        }

        const key = unitType + '_' + unitId;
        if (!itemsToRefresh.has(key)) {
            itemsToRefresh.set(key, { id: unitId, type: unitType });
        }
    });

    itemsToRefresh.forEach((item) => {
        loadUnitDetails(item.id, item.type, collectionId);
    });
}

window.loadUnitDetails = function(unit_id, unit_type, collectionId, currentItemData = []){

    window.currentLearningUnitId = unit_id;
    window.currentLearningUnitType = unit_type;

    let pathId = sessionStorage.getItem('collection_path_id')

    const url = '/details/' + unit_id + '/' + unit_type;
    const loader    = $('#skeleton-wrapper-' + unit_id + '-' + unit_type);


    let regularUnitSelector = $('#main-details-' + unit_type + '-' + unit_id)

    if (pathId && pathId != 0 && unit_type !== 'series' && unit_type !== 'learning_box') {
        regularUnitSelector = $('#path-' + pathId + ' #main-details-' + unit_type + '-' + unit_id)
    }

    const unit  = unit_type !== 'meeting' ? regularUnitSelector : $('*[data-meeting="' + unit_id + '"]');

    const match = window.location.href.match(/series|learning_box/);
    const collectionType = match ? match[0] : '';

    loader.fadeIn();

    $.ajax({
        type: 'GET',
        url: (collectionId && collectionId !== '') ? url + '/' + collectionId + '/' + collectionType : url,
        // async: false,
        data: {
            cart_items: localStorage.getItem('cart_items') || '',
            collection_id : collectionId,
            path_id: pathId,
            unit_type: unit_type
        },
        success: function (response) {
            // Hide skeleton
            loader.hide();

            const unit_parent = unit[0] ? unit[0].parentElement : null;
            const sequentialItemLine = unit_parent ? $(unit_parent).prev('.sequential-item-line') : $();
            const refreshedMarkup = $(JSON.parse(response.html));
            const sequentialAccess = refreshedMarkup.attr('data-sequential-access');
            const primaryActionButton = refreshedMarkup.find('.learning-unit-buttons .tiles-button, .learning-unit-buttons .btn').first();
            const unlocked = sequentialAccess !== undefined
                ? sequentialAccess === '1'
                : primaryActionButton.length
                    && !primaryActionButton.hasClass('disabled')
                    && !primaryActionButton.prop('disabled')
                    && !primaryActionButton.hasClass('skill_requirements_message');

            // Fill details and show
// <<<<<<< HEAD
//             if (unit.length) {
//                 unit.replaceWith(JSON.parse(response.html));
//             } else {
//                 if (!(collectionType && pathId == 0)) { // dont reload if user is on graphical collection
//                     location.reload()
// =======
            unit.replaceWith(refreshedMarkup);
            window.setSequentialLockIcon(sequentialItemLine, unlocked);

            // If we arrived from dashboard calendar to a collection page
            // (series or learning box), proactively load the target seminar
            // so we can auto-expand its meetings and open the info modal
            if (localStorage.getItem('redirected_from_calendar') && (unit_type === 'series' || unit_type === 'learning_box')) {
                const targetSeminarId = localStorage.getItem('redirected_to_target_seminar_id');
                // When landing on a curriculum page from the calendar we sometimes miss the collection id
                // (it comes in as empty), which prevents the seminar from loading its meetings. Default
                // the collection to the current unit so we keep the curriculum context.
                const targetCollectionId = collectionId || unit_id;

                if (targetSeminarId) {
                    try {
                        loadUnitDetails(targetSeminarId, window.global_vars.unit_types.seminar, targetCollectionId);
                    } catch (e) {
                        console.error(e);
                    }
                }
            }

            // for series, update certificate icon if series was completed
            if (collectionId !== '' && response.unitSettings != undefined  && response.unitSettings.certificate_icon != undefined && response.unitSettings.certificate_icon != null) {
                $('#curriculum-certificate-icon-element').replaceWith(response.unitSettings.certificate_icon)
            }

            // used for seminars frontend progress bar
            let progressBar = $('#progress');
            if(progressBar) {
                progressBar.width(response.progress + '%');
            }

            // Resize every image to same size
            resizeImage(document.querySelector("#unit_image_"+unit_id+"_"+unit_type));
            // Show hide "Show more" button
            checkShowMoreButton(unit_id, unit_type);

            if (response.unitMessage) {
                window.notification('success', response.unitMessage)
            }

            if(localStorage.getItem('redirected_from_calendar') && unit_type == 'seminar') {
                // Refresh seminar meetings for seminar
                expandMeetingsSection(unit_id, collectionId, false);
                localStorage.removeItem('redirected_from_calendar');
            }

            if (collectionType !== '' && currentItemData.length > 0) { // dont refresh on initial load of the page

                if (response.unitSettings.has_optional_units) { // in case of optional units we can not relay on partial reloading of curriculum items, instead we reload the whole page
                    location.reload()
                }

                if (response.unitStatus === 100) { // refresh all units, because in case of booking they need to be disabled

                    $.each($('*[id^="main-details-"]:gt(0)'), function(index, value) {

                        let id = value.getAttribute('data-id')
                        let type = value.getAttribute('data-unit-type')

                        loadUnitDetails(id, type, collectionId);
                    })

                } else if (response.unitSettings.sequential == 0) { // refresh only closed unit (curriculum is already updated)
                    loadUnitDetails(currentItemData[0], currentItemData[1], collectionId);
                    refreshSkillLockedUnits(collectionId, currentItemData);
                } else if (response.unitSettings.sequential == 1 && response.unitSettings.sequential_last_only == 0) { // refresh closed unit and the next one (curriculum is already updated)
                    let counter = 0
                    $.each($('*[id^="main-details-"]:gt(0)'), function(index, value) {
                        let id = value.getAttribute('data-id')
                        let type = value.getAttribute('data-unit-type')

                        if((id == currentItemData[0] && type == currentItemData[1]) || (counter > 0 && counter < 2)){
                            loadUnitDetails(id, type, collectionId);

                            // Refresh seminar meetings for seminar
                            if(type == 'seminar'){
                                expandMeetingsSection(id, collectionId, true);
                            }

                            counter++;
                        }

                    })

                    refreshSkillLockedUnits(collectionId, currentItemData);

                } else if (response.unitSettings.sequential == 1 && response.unitSettings.sequential_last_only == 1) { // refresh closed unit and the last one (curriculum is already updated)

                    let counter = 0;
                    let len = $('*[id^="main-details-"]:gt(0)').length
                    $.each($('*[id^="main-details-"]:gt(0)'), function(index, value) {

                        counter++;

                        let id = value.getAttribute('data-id')
                        let type = value.getAttribute('data-unit-type')

                        if((id == currentItemData[0] && type == currentItemData[1]) || counter == len){
                            loadUnitDetails(id, type, collectionId);

                            // Refresh seminar meetings for seminar
                            if(type == 'seminar'){
                                expandMeetingsSection(id, collectionId, true);
                            }

                        }

                    })

                    refreshSkillLockedUnits(collectionId, currentItemData);
                }

            }

            if (typeof unit_parent !== 'undefined' && unit_parent) {
                addClickEventListenerToRatingButton(unit_parent.querySelector('.rating-button'));
            }
        }
    });
}

window.showProgressBar = function(animation = 'animate', cleartime = 2000) {
    const progressBar = document.querySelector('.progress-line');

    if (progressBar) {
        progressBar.classList.add(animation);

        setTimeout(function() {
            progressBar.classList.remove(animation);
        }, cleartime)
    }

}

window.registerDatatablePageTracker = function(table, tableId, storageKey) {
    $('#' + tableId).on('page.dt', function () {
        let pageInfo = table.page.info();
        sessionStorage.setItem(storageKey, pageInfo ? pageInfo.page : 0)
    });

    let currentPage = sessionStorage.getItem(storageKey)
    table.page(Number(currentPage ? currentPage : 0)).draw(false)
}

// only if first column in table contains row id
window.addUnitIdsToDatatableRowsAsIds = function(table, prefix) {
    let currentPageRows = table.rows().data();

    for (let i = 0; i < currentPageRows.length; i++) {
        let currentId = currentPageRows[i][0]; // Assuming the first column always contains the ID
        let rowNode = table.row(i).node(); // Get the DOM element for the row
        rowNode.id = prefix + currentId;
    }
};

window.checkShowMoreButton = function(unit_id, unit_type){
    let smb = document.getElementById('show-more_'+unit_type+'_'+unit_id);
    let ud = document.getElementById('unit-description_'+unit_type+'_'+unit_id);

    if(ud && checkOverflow(ud)){
        smb.classList.add('visible');
    }
    if(smb){
        smb.addEventListener("click", function(){
            expandShowMore(ud, smb);
        }, false);
    }
}

window.checkOverflow = function(el){
    var curOverflow = el.style.overflow;

    if ( !curOverflow || curOverflow === "visible" )
        el.style.overflow = "hidden";

    var isOverflowing = el.clientWidth < el.scrollWidth
        || el.clientHeight < el.scrollHeight;

    el.style.overflow = curOverflow;

    return isOverflowing;
}
window.expandShowMore = function(desc, smb){
    desc.classList.toggle('increase-height');

    if(desc.classList.contains('increase-height')){
        smb.innerText = smb.dataset.less;
    }else{
        smb.innerText = smb.dataset.more;
    }
}

window.resizeImage = function(image){

    if(image){
        var currWidth = image.clientWidth;
        var currHeight = image.clientHeight;
        if(currWidth/3 > currHeight) {

            image.style["height"] = currWidth*0.5 + "px";
        } else if(currHeight/2 > currWidth){

            // image.style["width"] = "100%";
            // image.style["width"] = currWidth*0.7 + "px";
        }
    }
}

window.getBrowser = function() {

    // Firefox 1.0+
    var isFirefox = typeof InstallTrigger !== 'undefined';
    var isIE = /*@cc_on!@*/false || !!document.documentMode;

    if (isFirefox) {
        return 'FIREFOX';
    } else if(isIE) {
        return 'IE'
    }else{
        return 'OTHER'
    }

}

window.like = function(type, id){

    showProgressBar()

    $.ajax({
        type: 'POST',
        url: "/" + type + "/" + id + "/like",
        success: function (data) {
            // count.innerText = data.count;
            // let likeIcon = document.querySelector("#like_icon");
            // if(likeIcon){
            //     likeIcon.style.fill = data.color;
            // }

            let bu = document.getElementById('like-button_' + type + '_' + id)
            bu.getElementsByTagName('img')[0].src = data.image_url;

            let lc = document.getElementById('like-count_' + type + '_' + id)
            lc.textContent = data.count;

            if (data.pointsMessage !== null && data.pointsMessage !== undefined) {
                let message = data.pointsMessage;
                window.notification('success', message);

                let numberPattern = /\d+/g;

                let stringNumbers = message.match(numberPattern);

                if (stringNumbers.length > 0) {
                    window.updatePoints(stringNumbers[0]);
                }
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    [...document.getElementsByClassName('rating-star-container')].forEach(star => {
        let star_onclick = () => {
            starClicked(event.currentTarget.dataset.number);
        };
        star.addEventListener('click', star_onclick);
        star.addEventListener('keydown', () => {
            switch (event.key) {
                case ' ': {
                    event.preventDefault();
                    star_onclick();
                } break;

                case 'ArrowDown':
                case 'ArrowRight': {
                    event.preventDefault();
                    document.getElementById('rating-star-' + ((star.dataset.number) % 5 + 1)).focus();
                } break;

                case 'ArrowUp':
                case 'ArrowLeft': {
                    event.preventDefault();
                    document.getElementById('rating-star-' + (star.dataset.number == 1 ? 5 : (star.dataset.number - 1) % 5)).focus();
                } break;
            }

        });

        if(star.dataset.number == 1){
            star.tabIndex = 0;
        }

        let star_onfocus = () => {
            updateStarColours(event.currentTarget, true);
        };
        let star_onunfocus = () => {
            updateStarColours(event.currentTarget, false);
        };

        star.addEventListener('mouseenter', star_onfocus);
        star.addEventListener('focusin', star_onfocus);

        star.addEventListener('mouseleave', star_onunfocus);
        star.addEventListener('focusout', star_onunfocus);
    });

    [...document.getElementsByClassName('rating-button')].forEach(addClickEventListenerToRatingButton);
});

window.addClickEventListenerToRatingButton = (button) => {

    if (button) {
        button.addEventListener('click', () => {
            openRateModal(event.currentTarget.dataset.ratingPath, event.currentTarget.dataset.ratingId, event.currentTarget.dataset.userRating);
        });
        refreshStarFillLevel(button);
    }

};

window.refreshStarFillLevel = (button) => {
    let ratingAvg = Math.round(Number(button.querySelector('#rating-average_'+button.dataset.ratingId).innerText)*2)/2;
    button.querySelectorAll('.rating-small-star-icon').forEach((i) => {
        if(ratingAvg >= 1){
            i.querySelector('.rating-small-star-full').classList.remove('hidden');
        } else if(ratingAvg === 0.5){
            i.querySelector('.rating-small-star-half').classList.remove('hidden');
            i.querySelector('.rating-small-star-full').classList.add('hidden');
        } else{
            i.querySelector('.rating-small-star-half').classList.add('hidden');
            i.querySelector('.rating-small-star-full').classList.add('hidden');
        }

        ratingAvg--;
    });
};

window.openRateModal = (path, ratingId, userRating) => {
    event.stopPropagation();
    event.preventDefault();

    let ratingModal = document.getElementById('rating-modal');

    ratingModal.dataset.ratingPath = path;
    ratingModal.dataset.ratingId = ratingId;
    ratingModal.dataset.userRating = userRating;
    ratingModal.showModal();
    updateStarColours();
};

window.rateUnit = (csrf_token) => {
    let ratingModal = document.getElementById('rating-modal');

    let ratingBody = new FormData();
    ratingBody.append('stars', ratingModal.dataset.userRating);

    fetch(ratingModal.dataset.ratingPath, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'X-CSRF-Token': csrf_token,
        },
        body: ratingBody,
    })
        .then(response => response.json())
        .then((updatedRating) => {
            let id = ratingModal.dataset.ratingId;
            let button = document.getElementById('rating-button_'+id);
            button.dataset.userRating = updatedRating.userRating;
            document.getElementById('rating-average_'+id).innerText = Number(updatedRating.average).toFixed(1);
            document.getElementById('rating-count_'+id).innerText = updatedRating.count;

            refreshStarFillLevel(button);
        });

    document.getElementById('rating-modal').close();
};

window.updateStarColours = (star = null, enter = false, max_stars = 5) => {
    let rating = document.getElementById('rating-modal').dataset.userRating;
    let number = star ? star.dataset.number : 0;
    for(let i = 1; i <= max_stars; ++i){
        let starIcon = document.getElementById('rating-star-icon-'+i);
        let rating_star = document.getElementById('rating-star-'+i);

        rating_star.tabIndex = -1;
        rating_star.setAttribute('aria-checked', 'false');

        if(rating >= i){
            if(rating == i){
                rating_star.tabIndex = 0;
                rating_star.setAttribute('aria-checked', 'true');
            }

            if(i > number && enter){
                starIcon.style.fill = 'color-mix(in srgb, var(--ratingStarFillColor, orange) 50%, transparent)';
            } else {
                starIcon.style.fill = 'var(--ratingStarFillColor, orange)';
            }
            continue;
        }

        if(i <= number && enter){
            starIcon.style.fill = 'color-mix(in srgb, var(--ratingStarFillColor, orange) 50%, transparent)';
        } else{
            starIcon.style.fill = 'var(--ratingStarBackgroundColor, transparent)';
        }
    }
};

window.starClicked = (number) => {
    document.getElementById('rating-modal').dataset.userRating = number;
    updateStarColours();
};

window.goBrowserBack = function(forceReload = false) {
    localStorage.setItem('from-back', 1);

    if (forceReload) {
        sessionStorage.setItem('back-button-reload', 1);
    }

    window.history.back()
}

window.addEventListener('pageshow', (event) => {
    let forceReload = sessionStorage.getItem('back-button-reload');

    sessionStorage.setItem('back-button-reload', 0);

    if (forceReload == 1 && event.persisted) {
        location.reload();
    }
});



function handleFormSubmit(event) {
    // Find submit button with specified classes (all buttons)
    var submitButton = $(this).find('.btn.btn-primary.positive');

    // If button found, disable it (all buttons)
    if (submitButton.length > 0) {
        submitButton.prop("disabled", true);

        // Enable the button again after 2 seconds (all buttons)
        setTimeout(function () {
            submitButton.prop("disabled", false);
        }, 2000);
    }

    // Allow default form submission
    return true;
}

function handleModalFormSubmit(event) {
    if ($(this).closest('.modal').length > 0) {
        // Find and disable modal submit button
        var submitButtonInModal = $(this).closest('.modal').find('.btn.btn-primary.positive');
        submitButtonInModal.prop("disabled", true);

        // Shorter re-enable delay (optional)
        setTimeout(function () {
            submitButtonInModal.prop("disabled", false);
        }, 1000); // Adjust delay as needed
    }

    // Allow default form submission
    return true;
}

$(document).ready(function() {
    // Use event delegation for dynamically loaded content
    $(document).on('submit', 'form', handleFormSubmit);
    $(document).on('submit', '.modal form', handleModalFormSubmit); // Target modal forms
});

